import React, { useEffect, useState } from "react";
import MantineButton from "../../components/mantine/button";
import MantineSwitch from "../../components/mantine/switchbutton";
import MantineFlex from "../../components/mantine/flex";
import MantineSelect from "../../components/mantine/select";
import MantineTextInput from "../../components/mantine/textinput";
import { useForm } from "@mantine/form";
import { useDispatch, useSelector } from "react-redux";
import { getClientsList } from "../../store/actions";
import { UserRoles } from '../../helpers/constant'
import { onAddnewUser, onupdateUser } from "../../store/actions";
import { PlaceholderUi, hasCapitalLetter, hasMinimumLength, hasNoStartingNumber, hasNumber, hasSpecialCharacter, validateEmail, validateUserName, validatePassword, validatePhoneNumber } from "../../helpers/common";
import PasswordValidation from "../../components/common/passwordValidation";

const UserForm = (props: any) => {
    const { handleResponseUserForm, userData, modalclose, currentPrimaryColor, roleNames, setpasswordVal, passwordVal, clientNames } = props;
    const dispatch = useDispatch();
    const initialValues = {
        userName: '',
        email: '',
        userRoleId: '',
        phoneNumber: '',
        password: userData?.id === undefined ? '' : '',// Conditionally set password field
        clientId: '',
        twoFactorAuthentication: false
    };
    const validationRules: any = {
        userName: (val: any) => (validateUserName(val)),
        email: (val: any) => (validateEmail(val)),
        //phoneNumber: (val: any) => (validatePhoneNumber(val)),
        userRoleId: (val: any) => (val == null || val == 0 ? "Please Select Role" : null),
        clientId: (val: any) => (val ? null : "Please select a client"),
    };

    // Conditionally add password validation rule
    if (userData?.id === undefined) {
        validationRules.password = (val: any) => (validatePassword(val));
    }
    const handleCancel = (event: React.MouseEvent) => {
        event.preventDefault();
        modalclose();
      };
    const form = useForm({
        initialValues,
        validate: validationRules
    });
    const ispasswordCondition = form.values.password;
    const client = clientNames?.find((client: any) => client.value === form.values.clientId);

    const role = roleNames?.find((role: any) => role.value === form.values.userRoleId);

    const userFormData = () => {

        if (hasMinimumLength(ispasswordCondition) && hasNumber(ispasswordCondition) && hasSpecialCharacter(ispasswordCondition) && hasCapitalLetter(ispasswordCondition) && hasNoStartingNumber(ispasswordCondition))
           setpasswordVal(true)
        else setpasswordVal(false)
        form.validate();
        if (form.isValid()) {
            const data = {
                ...form.values,
                "id": userData?.id,
                "userName": form.values.userName,
                "email": form.values.email,
                "userRoleId": role ? role.value : '',
                "clientId": client ? client.value : '',
                "password": userData?.id === undefined ? form.values.password : undefined, // Conditionally set password field
                twoFA: form.values.twoFactorAuthentication ?? false,
            };

            if (data?.id == undefined) {
                const filteredData = Object.fromEntries(
                    Object.entries(data)?.filter(([_, value]) => value !== undefined)
                );
                dispatch(onAddnewUser(filteredData, handleResponseUserForm))
            } else {
                dispatch(onupdateUser(data, handleResponseUserForm))
            }
        }

    }

    const { getClient, getrole } = useSelector((state: any) => ({
        getClient: state?.getclientData?.clientdropdown || [],
        getrole: state?.getuserData?.getrole || []
    }));


    useEffect(() => {
        const SelectedClient = getClient?.find((client: any) => client.name === userData?.clientName);
        const roleSelected = getrole?.find((role: any) => role.roleName === userData?.roleName);
        if (userData) {
            form.setValues({
                email: userData?.email,
                phoneNumber: userData?.phoneNumber,
                userName: userData?.userName,
                clientId: SelectedClient?.id ? String(SelectedClient.id) : "",
                userRoleId: roleSelected?.id ? String(roleSelected.id) : "",
                twoFactorAuthentication: userData?.twoFactorAuthentication || false
            });
            setpasswordVal(false);
        }
    }, [userData]);
    return (
        <>
            <form onSubmit={form.onSubmit(userFormData)}>
                <MantineFlex className='flex-wrap md:flex-nowrap md:gap-4'>
                    <div className="w-full my-2">
                        <MantineTextInput
                            {...form.getInputProps('userName')}
                            label={<span>Customer ID <span style={{ color: 'red' }}>*</span></span>}
                            placeholder="Enter Your Customer ID"
                            value={form.values.userName}
                            onChange={(event: any) => form.setFieldValue('userName', event.currentTarget.value)}
                            classNames={{ input: `${PlaceholderUi}`, label: "text-sm" }}
                            error={form.errors.userName}
                        />

                    </div>
                    <div className="w-full my-2">
                        <MantineSelect
                            {...form.getInputProps('userRoleId')}
                            label={<span>Role <span style={{ color: 'red' }}>*</span></span>}
                            placeholder={'Select Role'}
                            data={roleNames}
                            classNames={{ input: `${PlaceholderUi}` }}
                            error={form.errors.userRoleId}
                        />

                    </div>
                </MantineFlex>
                <MantineFlex className='flex-wrap md:flex-nowrap md:gap-4'>
                    <div className="w-full my-2">
                        <MantineSelect
                            {...form.getInputProps('clientId')}
                            label={<span>Client Name <span style={{ color: 'red' }}>*</span></span>}
                            placeholder="Select a Client Name"
                            data={clientNames}
                            error={form.errors.clientId}
                            classNames={{ input: `${PlaceholderUi}`, label: "text-sm" }}
                        />

                    </div>
                    <div className="w-full my-2">
                        <MantineTextInput
                            {...form.getInputProps('email')}
                            label={<span>Email <span style={{ color: 'red' }}>*</span></span>}
                            placeholder="Enter Your Email"
                            value={form.values.email}
                            onChange={(event: any) => form.setFieldValue('email', event.currentTarget.value)}
                            error={form.errors.email}
                            classNames={{ input: `${PlaceholderUi}`, label: "text-sm" }}
                        />
                    </div>
                </MantineFlex>
                <MantineFlex className='flex-wrap md:flex-nowrap md:gap-4'>
                    <div className="w-full my-2 mt-1">

                        {userData?.id === undefined && (
                            <>
                                <MantineTextInput
                                    {...form.getInputProps('password')}
                                    label={<span>Password <span style={{ color: 'red' }}>*</span></span>}
                                    placeholder="Enter Your Password"
                                    value={form.values.password ?? ''}
                                    onChange={(event: any) => form.setFieldValue('password', event.currentTarget.value)}
                                    classNames={{ innerInput: `placeholder-input_placeholder`, input: `${PlaceholderUi}`, label: "text-sm" }}
                                    error={form.errors.password}
                                />
                                <PasswordValidation ispasswordCondition={ispasswordCondition} className="mt-3 px-1" />
                            </>
                        )}
                    </div>
                    <div className="w-full my-2 mt-1">                     
                        <MantineSwitch
                            label={<span> 2 FA</span>}
                            checked={form.values?.twoFactorAuthentication}                     
                            onChange={(checked:any) => form.setFieldValue("twoFactorAuthentication", checked)}
                            color="blue"
                            disabled={false}
                            value={form.values.email}
                            classNames={{ label: "text-sm" }}
                        />
                    </div>
                </MantineFlex>               
                <MantineFlex justify='flex-end' className='gap-4'>
                    <MantineButton name={'Save'} className={" mt-[15px] text-sm font-thin !w-[90px]"} color={currentPrimaryColor} />
                    <MantineButton name={'Cancel'} className={"bg-secondary_color hover:bg-hover_secondary_btn mt-[15px] text-sm font-thin !w-[100px]"} onClick={handleCancel} />
                </MantineFlex>
            </form>
        </>
    )
}
export default UserForm;